// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dragged-item {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 200;\n  cursor: pointer;\n  pointer-events: none;\n}\n.dragged-item .zone {\n  position: absolute;\n  width: 50px;\n  height: 30px;\n  background-color: #ccc;\n  opacity: 0.5;\n  transform: translate(-50%, -50%);\n}\n.dragged-item .visu {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(-50%, -10%);\n}\n", ""]);
// Exports
module.exports = exports;
